import { render } from "./TagsSelection.vue?vue&type=template&id=f9e4242c&ts=true"
import script from "./TagsSelection.vue?vue&type=script&lang=ts"
export * from "./TagsSelection.vue?vue&type=script&lang=ts"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__